<button nz-popconfirm [nzPopconfirmTitle]="translate(i18nKeys.ConfirmDelete) | async"
    [nzOkText]="translate(i18nKeys.OK) | async" [nzCancelText]="translate(i18nKeys.Cancel) | async"
    (nzOnConfirm)="confirm.emit()" nzPopconfirmPlacement="bottom" nzType="link" nz-button
    [nzTooltipTitle]="translate(i18nKeys.Delete) | async" nz-tooltip nzTooltipPlacement="topLeft">
    <i nz-icon nzType="delete"></i>
</button>